import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import { getAssistantExperience } from "features/productAssistant/assistantExperience";
import { getHeaderPageMeta } from "Layout/pageMeta";

export function useBrandMetadata() {
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();
    const isLocalDevelopment = hostname === "localhost" || hostname === "127.0.0.1";
    const user = decodeJwt();
    const brandName = isLocalDevelopment
      ? getAssistantExperience(user).brandName
      : hostname === "app.relibuild.com"
        ? "RELiBUILD"
        : "The Tradesmen's Collective";
    const faviconName = brandName === "RELiBUILD" ? "relibuild-favicon.ico" : "favicon.ico";
    const faviconHref = `${process.env.PUBLIC_URL || ""}/${faviconName}`;
    const pageTitle = getHeaderPageMeta(location.pathname, location.search, user?.userType).title;
    const nextTitle = location.pathname === "/" || location.pathname === "/dashboard"
      ? `${brandName} Dashboard`
      : `${pageTitle} | ${brandName}`;

    const faviconLinks = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]'));
    if (!faviconLinks.length) {
      const link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
      faviconLinks.push(link);
    }
    faviconLinks.forEach((link) => {
      link.href = faviconHref;
      link.type = "image/x-icon";
    });
    document.title = nextTitle;
  }, [location.pathname, location.search]);
}
